import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { uniformeModulo } from "src/app/aplicaciones-modulos/spyral/diccionarios/uniformeModule";
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { ClaveValorModel } from '../../model/claveValorModel';
import { ClothesEmploye } from '../../model/clothesEmployeModel';
import { DeliverClothesModel } from '../../model/deliverClothesModel';
import { DetalleEntregaModel } from '../../model/detalleEntregaModel';
import { HistoryDeliverModel } from '../../model/historyDeliverModel';
import { ResponseInfoDeliverClothesModel } from '../../model/responseInfoDeliverClothesModel';
import { ResponseSizeModel } from '../../model/responseSizeModel';
import { CatalogoService } from '../../services/catalogo.service';
import { DeliverClothesService } from "../../services/deliver-clothes.service";
import { ReportDeliverService } from '../../services/reportDeliver.service';
@Component({
  selector: 'app-dotacion-uniforme',
  templateUrl: './dotacion-uniforme.component.html',
  styleUrls: ['./dotacion-uniforme.component.css']
})
export class DotacionUniformeComponent implements OnInit {

  mostrarFormulario: boolean = false;
  resposiveFull: string;
  listaVacia: boolean = false;
  listaVaciaHistory: boolean = false;
  listaVaciaDetail: boolean = false;
  columnDefs: any[];//aggrid
  columnDefsEntrega: any[];
  columnDefsHistory: any[];
  columnDefsDetail: any[];
  clothesModulo: any = {};
  rowData: ClothesEmploye[] = [];
  rowDataEntrega: DeliverClothesModel[] = [];
  rowDataHistory: HistoryDeliverModel[] = [];
  rowDataDetail: DetalleEntregaModel[] = [];

  textoBuscar: string;
  textoBuscarEntrega: string;
  textoBuscarHistory: string;
  textoBuscarDetail: string;
  respSize: ResponseSizeModel[] = [];
  cmbOpcionesTalla: any[] = [];
  cmbTipoDeliver: ClaveValorModel[] = [];
  cmbTipoReport: ClaveValorModel[] = [];

  formulario: FormGroup;
  formularioTalla: FormGroup;
  formularioCantTipo: FormGroup;
  formularioReport: FormGroup;

  frameworkComponents: any;
  frameworkComponentsDetail: any;
  frameworkComponentsEntrega: any;
  frameworkComponentsHistory: any;
  gridApi: any;
  gridApiEntrega: any;
  gridApiHistory: any;
  gridApiDetail: any;
  gridColumnApi: any;
  gridColumnApiEntrega: any;
  gridColumnApiHistory: any;
  gridColumnApiDetail: any;
  rowSelection: any;
  rowSelectionEntrega: any;
  rowSelectionHistory: any;
  rowSelectionDetail: any;

  infoDeliverClothes: ResponseInfoDeliverClothesModel = new ResponseInfoDeliverClothesModel();
  seletedCLothesEmploye: ClothesEmploye;
  seletedDeliverClothes: DeliverClothesModel;
  seletedHistoryEntrega: HistoryDeliverModel;

  loading:boolean = false;

  constructor(private fb: FormBuilder, private _util: UtilsService,
              private _deliverClothes: DeliverClothesService, private _reportDeliver: ReportDeliverService,
              private _catalogo: CatalogoService) { }

  ngOnInit() {
    this.clothesModulo = uniformeModulo;
    this.resposiveFull = this.clothesModulo.div.resposiveFull;

    this.cmbTipoDeliver = this._catalogo.getTipoDeliver();
    this.cmbTipoReport = this._catalogo.getTipoReport();

    this.formulario = this.fb.group({
      cedula: ['',[Validators.required, Validators.maxLength(10)]],
      predaXentregar: [''],
      ccosto: [''],
      depart: [''],
      filial: [''],
      fullname: [''],
    });

    this.formularioTalla = this.fb.group({
      size: ['',[Validators.required]],
      codbaan: [''],
      descrp: ['']
    });

    this.formularioCantTipo = this.fb.group({
      tipo: ['',[Validators.required]],
      cant: ['',[Validators.required]],
      codbaan: [''],
      descrp: ['']
    });

    this.formularioReport = this.fb.group({
      fechaIni: ['',[Validators.required]],
      fechaFin: ['',[Validators.required]],
      tipo: ['',[Validators.required]],
    });

    this.cargarGrid();
    this.cargarGridEntrega();
    this.cargarGridHistory();
    this.cargarGridDetail();

  }

  cargarGrid() {
    this.columnDefs = [
      {
        headerName: 'Codigo',
        field: 'pieza.codBaan',
        filter: true,
        width: 100,
      },
      {
        headerName: 'Descripcion',
        field: 'pieza.descrp',
        filter: true,
        width: 200
      },
      {
        headerName: 'Cantidad',
        field: 'quantity',
        filter: true,
        width: 150
      },
      {
        headerName: 'Cupo Disponibe',
        field: 'available',
        filter: true,
        width: 150
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.callModalTalla.bind(this),
          label: "Editar",
        }
      }
    ];

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelection = 'multiple';

  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  cargarGridEntrega() {
    this.columnDefsEntrega = [
      {
        headerName: 'Codigo',
        field: 'codigo',
        filter: true,
        width: 120,
      },
      {
        headerName: 'Descripcion',
        field: 'descrp',
        filter: true,
        width: 200
      },
      {
        headerName: 'Grupo',
        field: 'grupoSZ',
        filter: true,
        width: 110
      },
      {
        headerName: 'Cupo Disponibe',
        field: 'cantdRec',
        filter: true,
        width: 170
      },
      {
        headerName: 'Cantidad',
        field: 'cantd',
        filter: true,
        width: 170
      },
      {
        headerName: 'Talla',
        field: 'talla',
        filter: true,
        width: 110
      },
      {
        headerName: 'Tipo',
        field: 'entrega',
        filter: true,
        width: 110,
        valueGetter: function(param){
          return param.data.entrega == true ? 'Entrega' : 'Recepcion';
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.deleteElementDeliverClothes.bind(this),
          label: "Eliminar",
        }
      }
    ];

    this.frameworkComponentsEntrega = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelectionEntrega = 'multiple';

  }

  onQuickFilterChangedEntrega() {
    this.gridApiEntrega.setQuickFilter(this.textoBuscarEntrega);
  }

  onGridReadyEntrega(params) {
    this.gridApiEntrega = params.api;
    this.gridColumnApiEntrega = params.columnApi;
  }

  cargarGridHistory() {
    this.columnDefsHistory = [
      {
        headerName: 'Dia',
        field: 'dia',
        filter: true,
        width: 88,
      },
      {
        headerName: 'Mes',
        field: 'mes',
        filter: true,
        width: 90
      },
      {
        headerName: 'Año',
        field: 'anio',
        filter: true,
        width: 88
      },
      {
        headerName: 'Prendas',
        field: 'prendas',
        filter: true,
        width: 110
      }
    ];
    this.frameworkComponentsHistory = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.rowSelectionHistory = 'multiple';

  }

  onQuickFilterChangedHistory() {
    this.gridApiHistory.setQuickFilter(this.textoBuscarHistory);
  }

  onGridReadyHistory(params) {
    this.gridApiHistory = params.api;
    this.gridColumnApiHistory = params.columnApi;
  }

  cargarGridDetail() {
    this.columnDefsDetail = [
      {
        headerName: 'Cant. Recibida',
        field: 'cantRec',
        filter: true,
        width: 150,
      },
      {
        headerName: 'Item',
        field: 'item',
        filter: true,
        width: 300
      },
      {
        headerName: 'Talla',
        field: 'codSize',
        filter: true,
        width: 110
      },
      {
        headerName: 'Hora Entrega',
        field: 'fechaMovto',
        filter: true,
        width: 150
      }
    ];
    this.frameworkComponentsDetail = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelection = 'multiple';

  }

  onQuickFilterChangedDetail() {
    this.gridApiDetail.setQuickFilter(this.textoBuscarDetail);
  }

  onGridReadyDetail(params) {
    this.gridApiDetail = params.api;
    this.gridColumnApiDetail = params.columnApi;
  }

  llenarDatosEmpleado(){
    this.formulario.get('predaXentregar').setValue(this.infoDeliverClothes.totalPrendas);
    this.formulario.get('ccosto').setValue(this.infoDeliverClothes.employee.ccosto);
    this.formulario.get('depart').setValue(this.infoDeliverClothes.employee.departamento);
    this.formulario.get('fullname').setValue(this.infoDeliverClothes.employee.nombres);
    console.log(this.infoDeliverClothes);
  }

  limpiarDatosEmpleado(){
    this.rowData = [];
    this.gridApi.setRowData(this.rowData);
    this.formulario.get('predaXentregar').setValue("");
    this.formulario.get('ccosto').setValue("");
    this.formulario.get('depart').setValue("");
    this.formulario.get('fullname').setValue("");
  }

  buscarInfoEmpleado(){
    this.limpiarDatosEmpleado();
    this._deliverClothes.findInfoEmploye(this.formulario.get('cedula').value).subscribe((res:ResponseInfoDeliverClothesModel)=>{
      this.infoDeliverClothes = res;
      this.rowData = this.infoDeliverClothes.clothesEmployes;
      this.llenarDatosEmpleado();
      this._util.mensajeOKToast("Busqueda exitosa.");
      this.listaVacia = false;
    },(err)=>{
      console.log(err);
      this.limpiarDatosEmpleado();
      this.listaVacia = true;
      this.infoDeliverClothes = new ResponseInfoDeliverClothesModel();
      if(err.error.key == '500'){
        this._util.mensajeErroToast(err.error.message);
      }else{
        this._util.mensajeErroToast('No se encontro información.');
      }
    });
  }

  callModalTalla(event){
    this.seletedCLothesEmploye  = event.rowData;
    
    this.formularioTalla.get('codbaan').setValue(this.seletedCLothesEmploye.pieza.codBaan)
    this.formularioTalla.get('descrp').setValue(this.seletedCLothesEmploye.pieza.descrp)
    this.buscarTallaByClothes(this.seletedCLothesEmploye.pieza.codBaan.trim());

    document.getElementById('abrirModalTalla').click();
    
  }
  
  buscarTallaByClothes(codBaan: string){
    this.cmbOpcionesTalla = [];
    this._deliverClothes.findSizeClothes(codBaan).subscribe((res:ResponseSizeModel[])=>{
      this.respSize = res;
      this.respSize.forEach((item)=>{
        this.cmbOpcionesTalla.push({clave: item.cEUSizesPK.codSize, valor: item.descrp});
      });
    },(err)=>{
      console.log(err);
      this.respSize = [];
      this.cmbOpcionesTalla = [];
      if(err.error.key == '500'){
        this._util.mensajeErroToast(err.error.message);
      }else{
        this._util.mensajeErroToast('No se encontro información.');
      }
    });
  }

  addElementToClothesDeliver(){
    let item: any = this.formularioTalla.value;
    if(item.size != undefined && item.size != ''){
      const index = this.rowData.findIndex((e) => e.pieza.codBaan === item.codbaan);
      let clothesEmploye:ClothesEmploye = this.rowData[index];
      
      let column: DeliverClothesModel = new DeliverClothesModel();
      column.codigo = item.codbaan.trim();
      column.descrp = item.descrp;
      column.talla = item.size;
      column.cantdRec = clothesEmploye.available;
      column.grupoSZ = clothesEmploye.pieza.grupoSz;
      column.entrega = clothesEmploye.available > 0 ? true : false;
      column.cantd = 1;

      this.rowDataEntrega.push(column);
      this.gridApiEntrega.setRowData(this.rowDataEntrega);

      document.getElementById('cerrarModalTalla').click();
    }else{
      this._util.mensajeErrorVisto('Debe seleccionar una talla');
    }
    
  }

  deleteElementDeliverClothes({rowData}){
    const index = this.rowDataEntrega.findIndex((e) => e.codigo === rowData.codigo);
    this.rowDataEntrega.splice(index, 1);
    this.gridApiEntrega.setRowData(this.rowDataEntrega);
  }

  callModalCantidadTipo(event){
    this.seletedDeliverClothes = event.data;

    this.formularioCantTipo.get('tipo').setValue(this.seletedDeliverClothes.entrega+'');
    this.formularioCantTipo.get('codbaan').setValue(this.seletedDeliverClothes.codigo);
    this.formularioCantTipo.get('cant').setValue(this.seletedDeliverClothes.cantd);
    this.formularioCantTipo.get('descrp').setValue(this.seletedDeliverClothes.descrp);

    document.getElementById('abrirModalCantidadTipo').click();
  }

  setDeliverClothes(){
    let data = this.seletedDeliverClothes;

    if (data.cantdRec < Number(this.formularioCantTipo.get('cant').value) && this.formularioCantTipo.get('tipo').value == 'true') {
      this._util.mensajeErrorVisto('Supero el cupo disponible');
      return;
    } else if (this.formularioCantTipo.get('tipo').value == 'false') {
      const indexPrincipal = this.rowData.findIndex((e) => e.pieza.codBaan.trim() === data.codigo);    
      let temp = this.formularioCantTipo.value;
      if(this.rowData[indexPrincipal].quantity < (Number(temp.cant) + data.cantdRec)){
        this._util.mensajeErrorVisto('Supero la cantidad Dispuesta para esta prenda');
        return;
      }
    }
    const index = this.rowDataEntrega.findIndex((e) => e.codigo === this.seletedDeliverClothes.codigo);
    
    data.cantd = Number(this.formularioCantTipo.get('cant').value);
    data.entrega = (this.formularioCantTipo.get('tipo').value == 'true') ? true : false;

    this.rowDataEntrega.splice(index, 1, data);
    this.gridApiEntrega.setRowData(this.rowDataEntrega);
    document.getElementById('cerrarModalCantidadTipo').click();

  }

  saveDriverClothes(){
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea guardar los Movimientos de Prendas?',
        text: '',
        action: 'Guardar',
        funcion: this._deliverClothes.createDeliverClothes(this.infoDeliverClothes.employee.cedula, this.rowDataEntrega),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarDatosEmpleado();
      this.formularioCantTipo.reset();
      this.formularioTalla.reset();
      this.rowData = [];
      this.rowDataEntrega = [];
      this.cmbOpcionesTalla = [];
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

  printActaEntrega(){
    if(this.infoDeliverClothes.employee == undefined || this.infoDeliverClothes == null || this.infoDeliverClothes.employee.cedula == undefined || this.infoDeliverClothes.employee.cedula  == ''){
      this._util.mensajeErrorVisto('Debe propinar un número de cédula');
    }else{
      this._reportDeliver.findActaEntrega(this.infoDeliverClothes.employee.cedula, ' ').subscribe((res:ClaveValorModel)=>{    
        this._util.descargarArchivo(res.clave, res.valor);
        this._util.mensajeOKToast("Descarga exitosa.");
      },(err)=>{
        console.log(err);
        this._util.mensajeErrorVisto("Descarga fallida.");
      });
    }
  }

  callModalHistory(){
    if(this.infoDeliverClothes == null || this.infoDeliverClothes.employee.cedula == undefined || this.infoDeliverClothes.employee.cedula  == ''){
      this._util.mensajeErrorVisto('Debe propinar un número de cédula');
    }else{
      this._reportDeliver.findHistory(this.infoDeliverClothes.employee.cedula ).subscribe((res:HistoryDeliverModel[])=>{    
        this.rowDataHistory = res;
        this._util.mensajeOKToast("Busqueda Exitosa.");
        this.listaVaciaHistory = false;
        document.getElementById('abrirModalHistory').click();
      },(err)=>{
        this.listaVaciaHistory = true;
        console.log(err);
        this._util.mensajeErrorVisto("Busqueda fallida.");
      });
    }
  }

  setListDetailEntrega(event){
    this.seletedHistoryEntrega = event.data;
    this.rowDataDetail = this.seletedHistoryEntrega.detalleEntrega;
    this.rowDataDetail.forEach((item)=>{
      item.fechaMovto = item.fechaMovto.substr(11,8);
    })
  }

  viewReporEntrega(){
    if(this.infoDeliverClothes == null || this.infoDeliverClothes.employee.cedula == undefined || this.infoDeliverClothes.employee.cedula  == ''){
      this._util.mensajeErrorVisto('Debe propinar un número de cédula');
    }else if(this.seletedHistoryEntrega == undefined || this.seletedHistoryEntrega.anio == undefined || this.seletedHistoryEntrega.anio == 0){
      this._util.mensajeErrorVisto('Debe seleccionar un Historial');
    }else{
      this._reportDeliver.findActaEntrega(this.infoDeliverClothes.employee.cedula, 
            this.seletedHistoryEntrega.anio + '-' + 
            (this.seletedHistoryEntrega.mes.toString().length == 1 ? '0' + this.seletedHistoryEntrega.mes : this.seletedHistoryEntrega.mes) + '-' + 
            (this.seletedHistoryEntrega.dia.toString().length == 1 ? '0' + this.seletedHistoryEntrega.dia : this.seletedHistoryEntrega.dia) 
          ).subscribe((res:ClaveValorModel)=>{    
        this._util.descargarArchivo(res.clave, res.valor);
        this._util.mensajeOKToast("Descarga exitosa.");
      },(err)=>{
        console.log(err);
        this._util.mensajeErrorVisto("Descarga fallida.");
      });
    }  
  }

  callReportWindows(){
    document.getElementById('abrirModalReport').click();
  }

  downloadReport(){
    let report: any = this.formularioReport.value;
    debugger;
    this._reportDeliver.generateReport(report.tipo, report.fechaIni, report.fechaFin).subscribe((res:ClaveValorModel)=>{    
      this._util.descargarArchivo(res.clave, res.valor);
      this._util.mensajeOKToast("Descarga exitosa.");
    },(err)=>{
      console.log(err);
      this._util.mensajeErrorVisto("Descarga fallida.");
    });
  }

}
